var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"adjustment-tabs",attrs:{"aria-label":"Inventory adjustment history"}},_vm._l((_vm.tabs),function(tab){return _c('router-link',{key:tab.to,staticClass:"adjustment-tab",class:{ active: _vm.isActive(tab.to) },attrs:{"to":tab.to}},[_c('i',{class:tab.icon,attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v(_vm._s(tab.label))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }